// test1204
(1204 && 0);
